export const emailTemplate = (name) => `
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">
    <tbody><tr>
        <td align="center" valign="top" id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665m_970753083176997002m_8600433492952329137m_3307279651307875277m_-2584769968685060036m_1328695559901438777m_8108127203805578926templateHeader" style="background: #020230 none no-repeat center/cover;background-color: #020230;background-image:none;background-repeat:no-repeat;background-position:center;background-size:cover;border-top:0;border-bottom:0;padding-top: 2em;padding-bottom: 2em;">
            
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;max-width:600px!important">
                <tbody>
                    <tr>
                        <td valign="top" style="background:#transparent none no-repeat center/cover;background-color:#transparent;background-image:none;background-repeat:no-repeat;background-position:center;background-size:cover;border-top:0;border-bottom:0;padding-top:0;padding-bottom:0"><table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse">
                        <tbody>
                            <tr>
                                <td valign="top" style="padding:9px">
                                    <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" style="min-width:100%;border-collapse:collapse">
                                        <tbody>
                                            <tr>
                                                <td valign="top" style="padding-right:9px;padding-left:9px;padding-top:0;padding-bottom:0;text-align:center">
                                    
                                        
                                                    <img align="center" alt="" src="https://orbittas.com/img/logo-white.png" width="564" style="max-width: 400px;padding-bottom:0;display:inline!important;vertical-align:bottom;border:0;height:auto;outline:none;text-decoration:none;" class="CToWUd"><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717:1iv" title="Descargar"><div></div></div></div><div dir="ltr" style="opacity:1"><div id="m_-8647660114504195717m_5748075296695398557:1fr"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455:1is"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647:1ae" title="Descargar"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666:1hr"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961:1ae"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289:18y" title="Descargar"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613:on"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659:q8"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138:qp"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665:1f6"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665m_970753083176997002:pn" title="Descargar"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665m_970753083176997002m_8600433492952329137:161"><div></div></div></div><div dir="ltr" style="opacity:0.01"><div id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665m_970753083176997002m_8600433492952329137m_3307279651307875277:103" title="Descargar"><div></div></div></div>
                                        
                                    
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            
        </td>
    </tr>
    <tr>
        <td align="center" valign="top" id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665m_970753083176997002m_8600433492952329137m_3307279651307875277m_-2584769968685060036m_1328695559901438777m_8108127203805578926templateBody" style="background:#ffffff none no-repeat center/cover;background-color:#ffffff;background-image:none;background-repeat:no-repeat;background-position:center;background-size:cover;border-top:0;border-bottom:0;padding-top:27px;padding-bottom:63px">
            
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;max-width:600px!important">
                <tbody><tr>
                    <td valign="top" style="background:#transparent none no-repeat center/cover;background-color:#transparent;background-image:none;background-repeat:no-repeat;background-position:center;background-size:cover;border-top:0;border-bottom:0;padding-top:0;padding-bottom:0"><table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse">
<tbody>
<tr>
<td valign="top" style="padding-top:9px">



<table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%;min-width:100%;border-collapse:collapse" width="100%">
<tbody><tr>

<td valign="top" style="padding-top:0;padding-right:18px;padding-bottom:9px;padding-left:18px;word-break:break-word;color:#39370e;font-family:Helvetica;font-size:16px;line-height:150%;text-align:left">

    <h2 style="display:block;margin:0;padding:0;color:#222222;font-family:Helvetica;font-size:28px;font-style:normal;font-weight:bold;line-height:150%;letter-spacing:normal;text-align:left"><br></h2>

<p style="margin:10px 0px;padding:0px;line-height:27px;font-size:18px">Hi ${name},</p><p style="margin:10px 0px;padding:0px;line-height:27px;font-size:18px">We have successfully received your email through our website. We will contact you soon to discuss details of your project.</p>

</td>
</tr>
</tbody></table>



</td>
</tr>
</tbody>
</table></td>
                </tr>
            </tbody></table>
            
        </td>
    </tr>
    <tr>
        <td align="center" valign="top" id="m_-8647660114504195717m_5748075296695398557m_2133402286235883455m_832155022924464647m_-468153288430959666m_6702542210627314961m_-7842835734801922289m_-5255220947697218613m_-5706224187820493659m_-3691265345840058138m_-4815881886720530665m_970753083176997002m_8600433492952329137m_3307279651307875277m_-2584769968685060036m_1328695559901438777m_8108127203805578926templateFooter" style="background: #34d3f3 none no-repeat center/cover;background-color: #34d3f3;background-image:none;background-repeat:no-repeat;background-position:center;background-size:cover;border-top:0;border-bottom:0;padding-top:11px;padding-bottom:11px;">
            
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;max-width:600px!important">
                <tbody><tr>
                    <td valign="top" style="background:#transparent none no-repeat center/cover;background-color:#transparent;background-image:none;background-repeat:no-repeat;background-position:center;background-size:cover;border-top:0;border-bottom:0;padding-top:0;padding-bottom:0"><table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse">
<tbody>
<tr>
<td align="center" valign="top" style="padding:9px">
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse">
<tbody><tr>
<td align="center" style="padding-left:9px;padding-right:9px">
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse">
<tbody><tr>
<td align="center" valign="top" style="padding-top:9px;padding-right:9px;padding-left:9px">
<table align="center" border="0" cellpadding="0" cellspacing="0" style="border-collapse:collapse">
    <tbody><tr>
        <td align="center" valign="top">
            
            
                
                
                
                    <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;border-collapse:collapse">
                        <tbody><tr>
                            <td valign="top" style="padding-right:10px;padding-bottom:9px">
                                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">
                                    <tbody><tr>
                                        <td align="left" valign="middle" style="padding-top:5px;padding-right:10px;padding-bottom:5px;padding-left:9px">
                                            <table align="left" border="0" cellpadding="0" cellspacing="0" width="" style="border-collapse:collapse">
                                                <tbody><tr>
                                                    
                                                        <td align="center" valign="middle" width="24">
                                                            <a href="https://www.facebook.com/orbittas" target="_blank" data-saferedirecturl="https://www.google.com/url?q=http://www.facebook.com/jesusrojasweb&amp;source=gmail&amp;ust=1623428383767000&amp;usg=AFQjCNGxlaDvGH62eEFrbbZDojQlXkaXuQ"><img src="https://ci6.googleusercontent.com/proxy/iZE-48sXvszGHh6MUoqCYHnlP8ohfGJI6V1fj23YRaJHEaKjOb2V7stez03tl97kcCY9ebD52HlFfqGKcTQbPlQaysAL26ZKjUSa5NGX7CU3WUodCbzb-vFMkIXxvIREY4PT879oIw=s0-d-e1-ft#https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-facebook-48.png" style="display:block;border:0;height:auto;outline:none;text-decoration:none" height="24" width="24" class="CToWUd"></a>
                                                        </td>
                                                    
                                                    
                                                </tr>
                                            </tbody></table>
                                        </td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                    </tbody></table>
                
                
            
                
                
                
                    
                
                
            
                
                
                
                    <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;border-collapse:collapse">
                        <tbody><tr>
                            <td valign="top" style="padding-right:10px;padding-bottom:9px">
                                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">
                                    <tbody><tr>
                                        <td align="left" valign="middle" style="padding-top:5px;padding-right:10px;padding-bottom:5px;padding-left:9px">
                                            <table align="left" border="0" cellpadding="0" cellspacing="0" width="" style="border-collapse:collapse">
                                                <tbody><tr>
                                                    
                                                        <td align="center" valign="middle" width="24">
                                                            <a href="https://www.instagram.com/orbittas/" target="_blank" data-saferedirecturl="https://www.google.com/url?q=http://www.instagram.com/jesusrojasweb&amp;source=gmail&amp;ust=1623428383767000&amp;usg=AFQjCNED3ly8H6jbliTQ6JwRNiUwPtRCPA"><img src="https://ci5.googleusercontent.com/proxy/Ihh9hEwk_36d3lzL_tLmGaqmGhc-dLqZP-II9LpKgUDCh37Kvw1N4-DJsrxuyAA9V1NNx3975BQO5w7DNVWvFHpPM4gkDm8eMVCLYy_PtGWEZAxMuaULgOR-6W0K_1sgXOcwNMtgGVE=s0-d-e1-ft#https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-instagram-48.png" style="display:block;border:0;height:auto;outline:none;text-decoration:none" height="24" width="24" class="CToWUd"></a>
                                                        </td>
                                                    
                                                    
                                                </tr>
                                            </tbody></table>
                                        </td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                    </tbody></table>
                
                
            
                
                
                
                    <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;border-collapse:collapse">
                        <tbody><tr>
                            <td valign="top" style="padding-right:10px;padding-bottom:9px">
                                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">
                                    <tbody><tr>
                                        <td align="left" valign="middle" style="padding-top:5px;padding-right:10px;padding-bottom:5px;padding-left:9px">
                                            <table align="left" border="0" cellpadding="0" cellspacing="0" width="" style="border-collapse:collapse">
                                                <tbody><tr>
                                                    
                                                        <td align="center" valign="middle" width="24">
                                                            <a href="https://www.linkedin.com/in/orbittas-technology-08538b210/" target="_blank" data-saferedirecturl="https://www.google.com/url?q=http://www.linkedin.com/in/jesusrojasweb&amp;source=gmail&amp;ust=1623428383768000&amp;usg=AFQjCNFzfzNRQK1WAFQ2cUI3gmBw4a2pLg"><img src="https://ci3.googleusercontent.com/proxy/FpKC1aFcvfDPI1MS2LGUKplthRlZAG8WmLpjZYlZ2DOVuaiIilo4gVSFwe9gvUOVkuK6WMw2dqEuxy4pfw2A5qShDQXqB56JtSw0EIbTBKiBrCFwkmwFDV8Q4ZB70NkcRlkMJuf5cw=s0-d-e1-ft#https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-linkedin-48.png" style="display:block;border:0;height:auto;outline:none;text-decoration:none" height="24" width="24" class="CToWUd"></a>
                                                        </td>
                                                    
                                                    
                                                </tr>
                                            </tbody></table>
                                        </td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                    </tbody></table>
                
                
            
                
                
                
                    
                
                
            
                
                
                
                    
                
                
            
                
                
                
                    <table align="left" border="0" cellpadding="0" cellspacing="0" style="display:inline;border-collapse:collapse">
                        <tbody><tr>
                            <td valign="top" style="padding-right:0;padding-bottom:9px">
                                <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">
                                    <tbody><tr>
                                        <td align="left" valign="middle" style="padding-top:5px;padding-right:10px;padding-bottom:5px;padding-left:9px">
                                            <table align="left" border="0" cellpadding="0" cellspacing="0" width="" style="border-collapse:collapse">
                                                <tbody><tr>
                                                    
                                                        <td align="center" valign="middle" width="24">
                                                            <a href="https://orbittas.com" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://jesusrojasweb.com.ve/&amp;source=gmail&amp;ust=1623428383768000&amp;usg=AFQjCNExIDRC8ztuFE_w-jRykzKYJ6uMYw"><img src="https://ci6.googleusercontent.com/proxy/uZ0yuxmORppOSAVlAI9An9dTGgd5WLSQ0CBL7MLu_J4uk8Z1QO7RWFmdlkUYkmd_GLhwph5RoVCp9eKrXzEQnDQ91cNlGygasb_4p2fT-TnBvWoJAX8mqJXeyuG36Kto6QrY=s0-d-e1-ft#https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-link-48.png" style="display:block;border:0;height:auto;outline:none;text-decoration:none" height="24" width="24" class="CToWUd"></a>
                                                        </td>
                                                    
                                                    
                                                </tr>
                                            </tbody></table>
                                        </td>
                                    </tr>
                                </tbody></table>
                            </td>
                        </tr>
                    </tbody></table>
                
                
            
            
        </td>
    </tr>
</tbody></table>
</td>
</tr>
</tbody></table>
</td>
</tr>
</tbody></table>

</td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse;table-layout:fixed!important">
<tbody>
<tr>
<td style="min-width:100%;padding:18px">
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-top:2px solid #ffffff;border-collapse:collapse">
<tbody><tr>
<td>
    <span></span>
</td>
</tr>
</tbody></table>

</td>
</tr>
</tbody>
</table><table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%;border-collapse:collapse">
<tbody>
<tr>
<td valign="top" style="padding-top:9px">



<table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%;min-width:100%;border-collapse:collapse" width="100%">
<tbody><tr>

<td valign="top" style="padding-top:0;padding-right:18px;padding-bottom:9px;padding-left:18px;word-break:break-word;color:#ffffff;font-family:Helvetica;font-size:12px;line-height:150%;text-align:center">

    <em>Copyright © 2021 orbittas, Todos los derechos reservados.</em><br>



</td>
</tr>
</tbody></table>



</td>
</tr>
</tbody>
</table></td>
                </tr>
            </tbody></table>
            
        </td>
    </tr>
</tbody></table>
`